export const GROWTH_CAMPAIGNS_META = {
  eyebrow: 'Google Ads · AI Suggestions',
  titleLead: 'Suggested',
  titleAccent: 'campaigns',
  description:
    "ELVA found these opportunities by combining your local market data with your clinic's strengths. Review the reasoning and launch with one click.",
  footerNote:
    "ELVA generates new suggestions as market conditions and clinic data evolve. Dismissed suggestions won't reappear.",
  emptyTitle: 'All caught up',
  emptyDescription:
    "You've reviewed all current suggestions. ELVA will surface new opportunities as market conditions change.",
} as const;
